import luoleAdminPages from './luole-admin-pages';

export default {
  'pages.layouts.userLayout.title': 'こんにちは！',
  'pages.getCaptchaSecondText': '秒',
  'pages.workbench.link': 'ようこそ',
  'pages.workbench.alertMessage':
    'より高速で強力な頑丈なコンポーネントがリリースされました。',
  'pages.404.subTitle':
    '申し訳ありませんが、アクセスしたページは存在しません。',
  'pages.404.buttonText': 'ホームに戻る',
  'pages.admin.subPage.title': 'このページは管理者のみが表示できます',
  'pages.admin.subPage.alertMessage':
    'Umi uiがリリースされました。npm run uiを使用して体験してください。',
  'pages.searchTable.createForm.newRule': '新しいルール',
  'pages.searchTable.updateForm.ruleConfig': 'ルール構成',
  'pages.searchTable.updateForm.basicConfig': '基本情報',
  'pages.searchTable.updateForm.ruleName.nameLabel': 'ルール名',
  'pages.searchTable.updateForm.ruleName.nameRules':
    'ルール名を入力してください！',
  'pages.searchTable.updateForm.ruleDesc.descLabel': 'ルールの説明',
  'pages.searchTable.updateForm.ruleDesc.descPlaceholder':
    '5文字以上入力してください',
  'pages.searchTable.updateForm.ruleDesc.descRules':
    '5文字以上のルールの説明を入力してください！',
  'pages.searchTable.updateForm.ruleProps.title': 'プロパティの構成',
  'pages.searchTable.updateForm.object': '監視対象',
  'pages.searchTable.updateForm.ruleProps.templateLabel': 'ルールテンプレート',
  'pages.searchTable.updateForm.ruleProps.typeLabel': 'ルールタイプ',
  'pages.searchTable.updateForm.schedulingPeriod.title':
    'スケジュール期間の設定',
  'pages.searchTable.updateForm.schedulingPeriod.timeLabel': '開始時間',
  'pages.searchTable.updateForm.schedulingPeriod.timeRules':
    '開始時間を選択してください！',
  'pages.searchTable.titleDesc': '説明',
  'pages.searchTable.ruleName': 'ルール名が必要です',
  'pages.searchTable.titleCallNo': 'サービスコール数',
  'pages.searchTable.titleStatus': 'ステータス',
  'pages.searchTable.nameStatus.default': 'デフォルト',
  'pages.searchTable.nameStatus.running': '起動中',
  'pages.searchTable.nameStatus.online': 'オンライン',
  'pages.searchTable.nameStatus.abnormal': '異常',
  'pages.searchTable.titleUpdatedAt': '最終スケジュール',
  'pages.searchTable.exception': '例外の理由を入力してください！',
  'pages.searchTable.titleOption': 'オプション',
  'pages.searchTable.config': '構成',
  'pages.searchTable.subscribeAlert': 'アラートを購読する',
  'pages.searchTable.title': 'お問い合わせフォーム',
  'pages.searchTable.new': '新しい',
  'pages.searchTable.chosen': '選んだ項目',
  'pages.searchTable.item': '項目',
  'pages.searchTable.totalServiceCalls': 'サービスコールの総数',
  'pages.searchTable.tenThousand': '万',
  'pages.searchTable.batchDeletion': 'バッチ削除',
  'pages.searchTable.batchApproval': 'バッチ承認',
  'pages.template.title': 'テンプレート',
  'pages.template.submit.success': 'フォームを送信しました！',
  'pages.template.form.name': '氏名',
  'pages.template.form.email': 'メール',
  'pages.template.form.department': '部署',
  'pages.template.form.joinDate': '入社日',
  'pages.template.form.remarks': '備考',
  'pages.template.placeholder.name': '氏名を入力してください',
  'pages.template.placeholder.email': 'メールを入力してください',
  'pages.template.placeholder.department': '部署を選択してください',
  'pages.template.placeholder.remarks': '備考を入力してください',
  'pages.template.validation.nameRequired': '氏名を入力してください',
  'pages.template.validation.emailRequired': 'メールを入力してください',
  'pages.template.validation.emailInvalid': 'メール形式が正しくありません',
  'pages.template.validation.departmentRequired': '部署を選択してください',
  'pages.template.validation.joinDateRequired': '入社日を選択してください',
  'pages.template.department.tech': '技術部',
  'pages.template.department.sales': '営業部',
  'pages.template.department.hr': '人事部',
  'pages.template.department.finance': '財務部',
  'pages.template.action.submit': '送信',
  'pages.template.action.reset': 'リセット',
  ...luoleAdminPages,
};
